import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AccessControlWrapper } from './AccessControlWrapper.js';
import { buildButton } from '../utils/buildButton.js';
/** the object props for building a PageHeaderButton from Utils */

var ButtonObjectPropType = PropTypes.shape({
  /** function to be called on click */
  action: PropTypes.func,

  /** bsPrefix applied to button */
  "class": PropTypes.string,

  /** is button disabled */
  disabled: PropTypes.bool,

  /** content rendered inside the button */
  label: PropTypes.any,

  /** any additional props to pass to the Button component */
  props: PropTypes.object
});
/** props for building a button by passing an element or building from Utils */

var ButtonPropType = PropTypes.oneOfType([PropTypes.element, ButtonObjectPropType]);
/** the props for creating a PageHeaderButton */

var PageHeaderButtonPropType = PropTypes.oneOfType([ButtonPropType, PropTypes.arrayOf(ButtonPropType)]);
/** renders a button or series of buttons in the PageHeader */

var PageHeaderButton = /*#__PURE__*/function (_Component) {
  function PageHeaderButton() {
    var _this;

    _classCallCheck(this, PageHeaderButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _callSuper(this, PageHeaderButton, [].concat(args));

    _defineProperty(_this, "renderButton", function () {
      var actionButton = _this.props.actionButton;

      if (Array.isArray(actionButton)) {
        return actionButton.map(function (button) {
          return _this.renderButtonFromObject(button);
        });
      } else if (actionButton.action) {
        return _this.renderButtonFromObject(actionButton);
      } else {
        return actionButton;
      }
    });

    _defineProperty(_this, "renderButtonFromObject", function (actionButton) {
      return /*#__PURE__*/React.createElement(AccessControlWrapper, actionButton, buildButton({
        func: actionButton.action,
        label: actionButton.label,
        bsPrefix: 'btn',
        variant: actionButton["class"],
        disabled: actionButton.disabled,
        props: actionButton.props
      }));
    });

    return _this;
  }

  _inherits(PageHeaderButton, _Component);

  return _createClass(PageHeaderButton, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "header-action-button"
      }, this.renderButton());
    }
  }]);
}(Component);

_defineProperty(PageHeaderButton, "propTypes", {
  /** the button being rendered */
  actionButton: PageHeaderButtonPropType
});

PageHeaderButton.displayName = "PageHeaderButton";
export { PageHeaderButton, PageHeaderButtonPropType };